import React from 'react';

import { Skeleton as MUISkeleton } from '@mui/material';
import Skeleton from 'app/shared/components/common/Skeleton/Skeleton';
import {
  DOCUMENT_LIST_HEIGHT,
  DOCUMENT_LIST_WIDTH,
} from 'app/shared/components/forms/FormEditor/FormEditor.styles';

import { SKELETON_TYPES } from 'constants/skeleton';

const skeletonStyles = {
  padding: '5rem 0',
};

const FormBuilderSkeleton = () => {
  return (
    <div className="h-full">
      <Skeleton length={1} type={SKELETON_TYPES.LIST} />
      <div className="flex justify-center" style={skeletonStyles}>
        <MUISkeleton
          animation="pulse"
          height={DOCUMENT_LIST_HEIGHT}
          variant="rectangular"
          width={DOCUMENT_LIST_WIDTH}
        />
      </div>
    </div>
  );
};

export default FormBuilderSkeleton;
